import type { sheetTypeEnum } from '@/utils/enum';
import { createContext, useContext } from 'react';
import type { z } from 'zod';

export type AnalysisSheetType = Extract<
  z.infer<typeof sheetTypeEnum>,
  'RS' | 'KS'
>;

const AnalysisSheetTypeContext = createContext<AnalysisSheetType | null>(null);

export const AnalysisSheetTypeProvider = AnalysisSheetTypeContext.Provider;

export const useAnalysisSheetType = (): AnalysisSheetType => {
  const value = useContext(AnalysisSheetTypeContext);
  if (!value) {
    throw new Error(
      'useAnalysisSheetType must be used within an AnalysisSheetTypeProvider',
    );
  }
  return value;
};
